<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Position Keeping</h5>
                  <h2 class=" card-title"><i class="fas fa-hand-holding-usd fa-lg"></i>&nbsp;&nbsp;&nbsp; Turnover & Protection</h2>
                </div>
                <div class=" col-sm-6">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedTurnoverTab=='Turnover'}"
                           (click)="selectedTurnoverTab='Turnover'">Turnover</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedTurnoverTab=='Protection'}"
                           (click)="selectedTurnoverTab='Protection'">Protection</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedTurnoverTab=='Performance'}"
                           (click)="selectedTurnoverTab='Performance'">Performance</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedTurnoverTab=='Turnover'">
                <!-- Turnover bar chart -->
                <app-basic-bar-chart *ngIf="investablePA.monthly_rebalancing"
                                     [series]="[
                            {label: 'turnover',   values: investablePA.monthly_rebalancing.accrued_turnover ? investablePA.monthly_rebalancing.accrued_turnover : undefined},
                            {label: 'pctTurnoverMax',  values: investablePA.monthly_rebalancing.turnover_pct_max ? investablePA.monthly_rebalancing.turnover_pct_max : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Turnover bar chart -->
              </div>
              <div *ngIf="selectedTurnoverTab=='Performance'">
                <!-- Performance bar chart -->
                <app-basic-bar-chart *ngIf="(investablePA.monthly_returns.original || is_standalone) &&
                                              (investablePA.monthly_returns.protected || !is_protected) &&
                                              investablePA.monthly_returns.investable &&
                                              investablePA.monthly_returns.benchmark"
                                     [series]="[
                            {label: 'original',   values: investablePA.monthly_returns.original ? investablePA.monthly_returns.original : undefined},
                            {label: 'investable', values: investablePA.monthly_returns.investable ? investablePA.monthly_returns.investable : undefined},
                            {label: 'protected',  values: investablePA.monthly_returns.protected ? investablePA.monthly_returns.protected : undefined},
                            {label: 'benchmark',  values: investablePA.monthly_returns.benchmark ? investablePA.monthly_returns.benchmark : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Performance bar chart -->
              </div>
              <div *ngIf="selectedTurnoverTab=='Protection'">
                <!-- Protection bar chart -->
                <app-basic-bar-chart *ngIf="investablePA.monthly_protection"
                                     [series]="[
                            {label: 'pctRiskBudget',    values: investablePA.monthly_protection.monthly_pct_risk ? investablePA.monthly_protection.monthly_pct_risk : undefined},
                            {label: 'maximum_drawdown', values: investablePA.monthly_protection.monthly_risk ? investablePA.monthly_protection.monthly_risk : undefined},
                            {label: 'cashAmount',       values: investablePA.monthly_protection.monthly_cash ? investablePA.monthly_protection.monthly_cash : undefined},
                            {label: 'riskyAsset',       values: investablePA.monthly_protection.monthly_risky_part ? investablePA.monthly_protection.monthly_risky_part : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Protection bar chart -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class=" content" *ngIf="investablePA">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title">{{ selectedTurnoverTab }}</h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <div *ngIf="selectedTurnoverTab=='Turnover' && investablePA">
                  <!-- Turnover table -->
                  <table id="tableToExport" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of monthly_dates" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="investablePA.monthly_rebalancing.monthly_rebalancing">
                      <th scope="row">Rebalancing</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_rebalancing.monthly_rebalancing[cat] }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_rebalancing.accrued_turnover">
                      <th scope="row">Turnover (accrued)</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_rebalancing.accrued_turnover[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_rebalancing.turnover_pct_max">
                      <th scope="row">% of Turnover Max</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_rebalancing.turnover_pct_max[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_rebalancing.turnover_annual_max">
                      <th scope="row">Annual Max</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_rebalancing.turnover_annual_max[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Turnover table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
                <div *ngIf="selectedTurnoverTab=='Protection' && investablePA">
                  <!-- Protection table -->
                  <table id="tableToExport" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of monthly_dates" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="investablePA.monthly_protection.monthly_risk">
                      <th scope="row">Max Drawdown</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_risk[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_pct_risk">
                      <th scope="row">% of Risk Budget</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_pct_risk[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_cash">
                      <th scope="row">Cash</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_cash[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_risky_part">
                      <th scope="row">Risky Asset</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_risky_part[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_breach_prot">
                      <th scope="row">Breach Protection</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_breach_prot[cat] }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_gap_risk">
                      <th scope="row">Gap Risk</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_gap_risk[cat] }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_protection.monthly_reset">
                      <th scope="row">Reset</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_protection.monthly_reset[cat] }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Protection table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
                <div *ngIf="selectedTurnoverTab=='Performance' && investablePA">
                  <!-- Performance table -->
                  <table id="tableToExport" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of monthly_dates" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="investablePA.monthly_returns.original">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_returns.original[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_returns.investable">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_returns.investable[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_returns.protected">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_returns.protected[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePA.monthly_returns.benchmark">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of monthly_dates">{{ investablePA.monthly_returns.benchmark[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Performance table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <br>
  </div>
</div>
